/**
 * The CSRF token is short-lived, replaced on every sign-in and refresh, and
 * has no bearing on rendering — so it lives here as a plain module variable
 * rather than in Zustand, keeping it out of persisted storage and out of
 * React's render cycle.
 */
let csrfToken = '';

export const getCsrfToken = (): string => csrfToken;

export const setCsrfToken = (token?: string | null): void => {
  csrfToken = token || '';
};
